import React from "react";
import {
  Card,
  CardContent,
  Chip,
  Stack,
  Typography,
} from "@mui/material";
import { useEnglishText } from "../../../text/useEnglishText.js";

const SubscriptionSummaryCard = ({ companyName, status, endsAt, isPaidLicense = status === "active_paid" }) => {
  const { t } = useEnglishText();
  const color = status === "expired" ? "error" : "success";
  const label = status === "expired"
    ? t("dashboard.expired", "Expired")
    : status === "active_paid"
      ? t("licenses.summary.activeLicense", "Active License")
      : t("licenses.summary.activeTrial", "Active Trial");

  return (
    <Card variant="outlined" sx={{ borderRadius: 3 }}>
      <CardContent>
        <Stack spacing={2}>
          <Typography variant="h6" fontWeight={700}>
            {t("licenses.summary.title", "License Request Summary")}
          </Typography>

          <Stack direction="row" justifyContent="space-between" alignItems="center" useFlexGap flexWrap="wrap" gap={1}>
            <Typography variant="body1">{companyName || "-"}</Typography>
            <Chip label={label} color={color} />
          </Stack>

          <Typography variant="body2" color="text.secondary">
            {endsAt
              ? `${isPaidLicense ? t("licenses.summary.licenseEndDate", "License end date") : t("licenses.summary.trialEndDate", "Trial end date")}: ${endsAt}`
              : t("licenses.summary.noDate", "No subscription date available.")}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default SubscriptionSummaryCard;
